import { render, staticRenderFns } from "./Educations.vue?vue&type=template&id=1bab4e2b&scoped=true&"
import script from "./Educations.vue?vue&type=script&lang=js&"
export * from "./Educations.vue?vue&type=script&lang=js&"
import style0 from "./Educations.vue?vue&type=style&index=0&id=1bab4e2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab4e2b",
  null
  
)

export default component.exports